import { memo } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@/icons";
import styles from "../FullscreenPresentationLayout.module.scss";
import type { TurnDirection } from "../types";

type PageControlProps = {
    currentSlide: number;
    totalSlides: number;
    onTurnSlide: (direction: TurnDirection) => void;
};

export const PageControl = memo(({ currentSlide, totalSlides, onTurnSlide }: PageControlProps) => {
    const handleClickPrevSlide = () => {
        onTurnSlide("prev");
    };
    const handleClickNextSlide = () => {
        onTurnSlide("next");
    };

    return (
        <div className={styles.pageControl}>
            <button
                className={styles.navigationButton}
                type="button"
                onClick={handleClickPrevSlide}
            >
                <ChevronLeftIcon />
            </button>

            <div className={styles.paging}>
                {currentSlide + 1} / {totalSlides}
            </div>

            <button
                className={styles.navigationButton}
                type="button"
                onClick={handleClickNextSlide}
            >
                <ChevronRightIcon />
            </button>
        </div>
    );
});
